import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Form } from 'react-bootstrap5';
import { ErrorMessage, useField } from 'formik';
import { Rating } from 'react-simple-star-rating';

import IconWithText from 'components/Widgets/IconWithText';

export default function RatingField(props) {
  const {
    id, name, label, hint, required, disabled, onClick,
  } = props;
  const [, meta, helpers] = useField(props);
  const { value } = meta;
  const { setValue } = helpers;
  const noneId = `${id}-none`;

  useEffect(() => {
    onClick();
  }, [value]);

  return (
    <Form.Group className="mb-5">
      {label && (
        <Form.Label>
          <>
            {label}
            {required && <abbr className="ms-1" title="required">*</abbr>}
          </>
        </Form.Label>
      )}

      <div className="d-md-flex align-items-center">
        <Rating
          key={`${name}-${value}`}
          initialValue={value === -1 ? 0 : value}
          emptyIcon={<IconWithText iconClassName="star-filled-icon bg-gray-300" />}
          fillIcon={<IconWithText iconClassName="star-filled-icon bg-tertiary-600" />}
          emptyClassName="d-flex"
          fillClassName="d-flex"
          readonly={disabled}
          onClick={(rate) => {
            setValue(rate);

            const noneRadioButton = document.querySelector(`#${noneId}`);
            noneRadioButton.checked = false;
          }}
        />

        <Form.Check
          type="radio"
          id={noneId}
          name={name}
          label="Not Applicable"
          className="d-md-inline-block mb-0 mt-3 mt-md-1 ms-1 ms-md-3"
          disabled={disabled}
          defaultChecked={value === -1}
          onClick={() => {
            setValue(-1);
          }}
        />
      </div>

      {hint && <Form.Text className="text-muted">{hint}</Form.Text>}

      <ErrorMessage
        name={name}
        render={(msg) => <Form.Control.Feedback type="invalid">{msg}</Form.Control.Feedback>}
      />
    </Form.Group>
  );
}

RatingField.propTypes = {
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
  hint: PropTypes.string,
  required: PropTypes.bool,
  disabled: PropTypes.bool,
  onClick: PropTypes.func,
};

RatingField.defaultProps = {
  hint: '',
  required: false,
  disabled: false,
  onClick: () => {},
};
